import type { AnyApiResponse, ApiResponse, ApiError } from '@/types/api';
import { ApiError as ApiErrorClass } from '@/types/api';

// Narrow unknown value to ApiResponse-like
export function isApiResponse(x: any): x is AnyApiResponse {
  return x && typeof x === 'object' && 'success' in x && 'message' in x;
}

// Ensure response.success === true, otherwise throw ApiError
export function ensureSuccess<T = unknown>(resp: AnyApiResponse<T>): ApiResponse<T> {
  if (!resp.success) {
    throw new ApiErrorClass(resp.message || 'Request failed', { errors: resp.errors, response: resp });
  }
  return resp as ApiResponse<T>;
}

// Return resp.data when success, else throw
export function unwrapData<T = unknown>(resp: AnyApiResponse<T>): T | null {
  const ok = ensureSuccess(resp);
  return (ok.data ?? null) as T | null;
}

// Soft unwrap: returns { ok, data, message, errors }
export function softUnwrap<T = unknown>(resp: AnyApiResponse<T>) {
  if (!resp) return { ok: false, data: null as T | null, message: 'No response', errors: null as unknown };
  return { ok: !!resp.success, data: (resp.data ?? null) as T | null, message: resp.message, errors: resp.errors };
}
